import { render, staticRenderFns } from "./a4form.vue?vue&type=template&id=a7b16538&scoped=true&"
import script from "./a4form.vue?vue&type=script&lang=js&"
export * from "./a4form.vue?vue&type=script&lang=js&"
import style0 from "./a4form.css?vue&type=style&index=0&id=a7b16538&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b16538",
  null
  
)

export default component.exports